document.addEventListener('DOMContentLoaded', () => {
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  const localStorageKey = 'shopify_wishlist';

  // Get current wishlist items array from LocalStorage
  let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];

  // Update button states on page load
  wishlistButtons.forEach(btn => {
    const handle = btn.getAttribute('data-wishlist-handle');
    if (wishlist.includes(handle)) {
      btn.classList.add('is-active');
    }
  });

  // Handle click events
  wishlistButtons.forEach(btn => {

    btn.addEventListener('click', (e) => {

      e.preventDefault();
      const handle = btn.getAttribute('data-wishlist-handle');
      
      if (wishlist.includes(handle)) {
        // Remove item
        wishlist = wishlist.filter(item => item !== handle);
        btn.classList.remove('is-active');
      } else {
        // Add item
        wishlist.push(handle);
        btn.classList.add('is-active');
      }

      //Update wishlist item on local storage
      localStorage.setItem(localStorageKey, JSON.stringify(wishlist));
   
    });
    
  });
  
});